/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';

export const timeToSubmissionDTOSchema = z.object({ "hours": z.number(), "isSubmitted": z.boolean().nullish() });
export type TimeToSubmissionDTO = z.infer<typeof timeToSubmissionDTOSchema>;
